import { useLocation, useNavigate } from 'react-router-dom';
import { getTenant } from './TenantUtils';

// Volta para a tela anterior (histórico, mantendo filtros/página da URL); aberta direto por link, vai para o destino padrão
export const useVoltar = () => {
    const navigate = useNavigate();
    const { key } = useLocation();
    return (padrao = `/${getTenant()}`) => key !== 'default' ? navigate(-1) : navigate(padrao, { replace: true });
};
